const ShoppingCartIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Alışveriş</title>
      <path
        d="M8.5 14.25C8.5 16.17 10.08 17.75 12 17.75C13.92 17.75 15.5 16.17 15.5 14.25"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M8.80945 2L5.18945 5.63"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M15.1914 2L18.8114 5.63"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M2 7.85059C2 6.00059 2.99 5.85059 4.22 5.85059H19.78C21.01 5.85059 22 6.00059 22 7.85059C22 10.0006 21.01 9.85059 19.78 9.85059H4.22C2.99 9.85059 2 10.0006 2 7.85059Z"
        stroke="#0091D5"
        strokeWidth="1.5"
      />{" "}
      <path
        d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeWidth="1.5"
      />{" "}
    </svg>
  );
};

export default ShoppingCartIcon;
